<script lang="ts">
  type Option = {
    value: string;
    label: string;
  };

  export let placeholder: string;
  export let onChange: ((value: string) => void) | undefined = undefined;
  export let value = "";
  export let optionList: Array<Option> = [];
  export let showPlaceholderOption = false;

  const handleChange = (e: Event) => {
    value = (e.target as HTMLInputElement).value;
    onChange && onChange(value);
  };
</script>

<select
  class="std-select font-MrEavesXLSanNarOT pr-[32px] relative text-[20px] px-[14px] w-full h-[42px] bg-grey border-solid border-transparent border-1 rounded-[8px] z-[10] outline-none laptop:h-[46px]"
  class:text-gray-400={!value && showPlaceholderOption}
  class:text-input={value}
  aria-label={placeholder}
  on:change={handleChange}
  bind:value
>
  {#if showPlaceholderOption}
    <option value="" selected disabled class="text-gray-400">{placeholder}</option>
  {/if}
  {#each optionList as { label, value }}
    <option {value} class="text-white">{label}</option>
  {/each}
</select>
